module.exports = __webpack_public_path__ + "static/media/vege-fish-breakfasts.51a50d67.pdf";